import "./index.css";
import { Route, BrowserRouter, Routes } from "react-router";
import Home from "@/pages/home";
import NotFound from "@/pages/NotFound";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
